import styled from 'styled-components/native'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'

export const StyledBorderBox = styled(Box)`
  bottom: 0;
  left: 0;
  width: 100%;
`

export const StyledPressable = styled(Pressable)`
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
`
